export default __webpack_public_path__ + "static/media/correct-hollow-check.01062164.svg";